import cookie from 'js-cookie';
import type { User } from 'types/User';
import * as uuid from 'uuid';

import facebook from '~/services/facebook';
import facebookPixel from '~/services/facebook.pixel';
import { sha256 } from '~/utils/hash';
import {
  getEntrypoint,
  getPageSeq,
  getPageViewId,
  getPreviousPagePath,
  getPreviousPagePosition,
  getPreviousPageType,
  getPreviousPageViewId,
  getSourceAndMedium
} from '~/utils/navigationContext';

import UserEvent from './UserEvent';

type EventData = {
  clientIp: string | null;
  isBot: boolean;
  pageType: string;
  url: string;
  user: User;
};

let sentPageViewId: string | undefined;

class PageViewEvent extends UserEvent<EventData> {
  async sendToFacebook() {
    const eventId = uuid.v4();

    await facebookPixel.fireEvent({
      eventID: eventId,
      eventName: facebookPixel.StandardEventNames.PageView
    });

    const hashedProfile = await facebook.getHashedProfile(
      this.data.user.profile
    );

    const externalId = await sha256(this.data.user.id ?? 'guest');

    const serverEventData = [
      {
        action_source: 'website',
        event_id: eventId,
        event_name: facebookPixel.StandardEventNames.PageView,
        event_source_url: window.location.href,
        event_time: Math.floor(Date.now() / 1000),
        user_data: {
          client_ip_address: this.data.clientIp,
          client_user_agent: navigator.userAgent,
          external_id: externalId,
          fbc: cookie.get('_fbc'),
          fbp: cookie.get('_fbp'),
          ...hashedProfile
        }
      }
    ];

    this.serverEvents.push({ data: serverEventData, type: 'facebook' });
  }

  collectServerEvents() {
    const pageViewId = getPageViewId();

    if (sentPageViewId === pageViewId) return;

    const pageSeq = getPageSeq();

    sentPageViewId = pageViewId;

    this.serverEvents.push({
      data: {
        client_ip: this.data.clientIp ?? undefined,
        entry_point: getEntrypoint(),
        is_entry: pageSeq <= 1,
        is_logged_in: this.data.user.isLoggedIn,
        page_location: window.location.href,
        page_path: window.location.pathname,
        page_seq: pageSeq,
        page_type: this.data.pageType,
        page_view_id: pageViewId,
        previous_page_path: getPreviousPagePath(),
        previous_page_position: getPreviousPagePosition(),
        previous_page_type: getPreviousPageType(),
        previous_page_view_id: getPreviousPageViewId(),
        referrer: document.referrer || undefined,
        source_medium: getSourceAndMedium(),
        url: this.data.url,
        useragent: navigator.userAgent,
        view_ts: Date.now()
      },
      type: 'page_view'
    });
  }
}

export default PageViewEvent;
